export const MESSAGE_KEY = 'PLANNING_GET_COORDS';
